import React, { Component } from "react";
import { Bar } from "react-chartjs-2";
class DiagramJabFung extends Component {
  state = {
    data: "",
  };

  options = {
    scales: {
      yAxes: [
        {
          ticks: {
            beginAtZero: true,
            userCallback: function(label, index, labels) {
              // when the floored value is the same as the value we have a whole number
              if (Math.floor(label) === label) {
                return label;
              }
            },
          },
        },
      ],
    },
  };
  render() {
    let jumlah = this.props.dataDosen?.data_dosen_jabfung || {};
    console.log(jumlah);
    let jabatan_fungsional = {
      labels: ["Data ini merupakan data yang diambil pada tahun ajaran 2020-2"],
      datasets: [
        {
          label: "Tanpa Jabatan",
          fill: false,
          lineTension: 0.1,
          backgroundColor: "#ebb2b2",
          borderColor: "#ebb2b2",
          borderCapStyle: "butt",
          borderDash: [],
          borderDashOffset: 0.0,
          borderJoinStyle: "miter",
          pointBorderColor: "#ebb2b2",
          pointBackgroundColor: "#ebb2b2",
          pointBorderWidth: 1,
          pointHoverRadius: 5,
          pointHoverBackgroundColor: "#ebb2b2",
          pointHoverBorderColor: "#ebb2b2",
          pointHoverBorderWidth: 2,
          pointRadius: 1,
          pointHitRadius: 10,
          data: [jumlah.tanpa_jabatan],
        },
        {
          label: "Asisten Ahli",
          fill: false,
          lineTension: 0.1,
          backgroundColor: "#b2bdeb",
          borderColor: "#b2bdeb",
          borderCapStyle: "butt",
          borderDash: [],
          borderDashOffset: 0.0,
          borderJoinStyle: "miter",
          pointBorderColor: "#b2bdeb",
          pointBackgroundColor: "#b2bdeb",
          pointBorderWidth: 1,
          pointHoverRadius: 5,
          pointHoverBackgroundColor: "#b2bdeb",
          pointHoverBorderColor: "#b2bdeb",
          pointHoverBorderWidth: 2,
          pointRadius: 1,
          pointHitRadius: 10,
          data: [jumlah.asisten_ahli],
        },
        {
          label: "Lektor",
          fill: false,
          lineTension: 0.1,
          backgroundColor: "#ebddb2",
          borderColor: "#ebddb2",
          borderCapStyle: "butt",
          borderDash: [],
          borderDashOffset: 0.0,
          borderJoinStyle: "miter",
          pointBorderColor: "#ebddb2",
          pointBackgroundColor: "#fff",
          pointBorderWidth: 1,
          pointHoverRadius: 5,
          pointHoverBackgroundColor: "#ebddb2",
          pointHoverBorderColor: "#ebddb2",
          pointHoverBorderWidth: 2,
          pointRadius: 1,
          pointHitRadius: 10,
          data: [jumlah.lektor],
        },
        {
          label: "Lektor Kepala",
          fill: false,
          lineTension: 0.1,
          backgroundColor: "#b2e8eb",
          borderColor: "#b2e8eb",
          borderCapStyle: "butt",
          borderDash: [],
          borderDashOffset: 0.0,
          borderJoinStyle: "miter",
          pointBorderColor: "#b2e8eb",
          pointBackgroundColor: "#fff",
          pointBorderWidth: 1,
          pointHoverRadius: 5,
          pointHoverBackgroundColor: "#b2e8eb",
          pointHoverBorderColor: "#b2e8eb",
          pointHoverBorderWidth: 2,
          pointRadius: 1,
          pointHitRadius: 10,
          data: [jumlah.lektor_kepala],
        },
        {
          label: "Guru Besar",
          fill: false,
          lineTension: 0.1,
          backgroundColor: "#b2ebb5",
          borderColor: "#b2ebb5",
          borderCapStyle: "butt",
          borderDash: [],
          borderDashOffset: 0.0,
          borderJoinStyle: "miter",
          pointBorderColor: "#b2ebb5",
          pointBackgroundColor: "#fff",
          pointBorderWidth: 1,
          pointHoverRadius: 5,
          pointHoverBackgroundColor: "#b2ebb5",
          pointHoverBorderColor: "#b2ebb5",
          pointHoverBorderWidth: 2,
          pointRadius: 1,
          pointHitRadius: 10,
          data: [jumlah.profesor],
        },
      ],
    };
    return (
      <>
        <div className={`card-custom `}>
          {/* Header */}
          <div
            className="card-header border-0"
            style={{ textAlign: "center", paddingBottom: "0px" }}
          >
            <h5
              className="card-title font-weight-bolder"
              style={{ color: "#354f7a" }}
            >
              Dosen Dengan Jabatan Fungsional
            </h5>
          </div>

          {/* Body */}
          <div className="card-body pt-2">
            <Bar data={jabatan_fungsional} options={this.options} />
          </div>
        </div>
      </>
    );
  }
}
export default DiagramJabFung;
